<mat-card appearance="outlined">
    <p>La descripción y la fecha coinciden con una inversión financiera ya registrada en Handly,
        ¿desea añadir los asientos contables a la inversión existente? </p>
    <button mat-stroked-button (click)="startImport()">Si, añadir asientos</button>
    <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
</mat-card>
